export default __webpack_public_path__ + "static/media/location_active.b2534788.png";